export const MuiTabs = {
    styleOverrides: {
        root: { borderBottom: "none" }
    }
};
//# sourceMappingURL=Tabs.js.map